//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { DownOutlined, DownloadOutlined, EyeOutlined, SettingOutlined } from "@ant-design/icons";
import { ArrowBack, Article, TaskAlt, HourglassEmpty } from '@mui/icons-material';
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextareaAutosize,
  Tooltip,
} from '@mui/material';
import { Button, Card, Checkbox, Col, Dropdown, Input, Modal, Pagination, Popover, Row, Select, Tabs } from "antd";
import SpinLoader from "components/Loader/SpinLoader";
import Loading from "components/Loading";
import PlacementExamViewSubmission from "components/PlacementExam/PlacementExamViewSubmission";
import IndividualStudentProficiencyReport from "./IndividualStudentProficiencyReport";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { debounce, find, isEmpty, map } from "lodash";
import moment from "moment-timezone";
import queryString from 'query-string';
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { usePlacementExamList, usePlacementExamSubmissiomByexamcode, useExamLevelConfig, getLevelsByConfig, usePlacementOrgConfig } from "store/placement_exam/selectors";
import { handleGetAllSubmissionRow, handleGetOverallAverage, handleGetPlacementOrgConfig, handleListPlacementexamForDistrict, handleListPlacementexamSubmissionsByCode, handleListPlacementexamSubmissionsByCodeFiltered, handlePlacementExamAiGrading, handlePlacementExamAiReGrading, handlePlacementOverallReport, handleReactivatePlacementExamSubmission, handleReportByYear, handleUpdatePlacementExamSubmissions } from "store/placement_exam/thunks";
import { handleGetSchoolsForOrg } from "store/organizations/thunks";
import { useCurrentUser } from "store/users/selectors";
import { useCurrentOrg } from "store/organizations/selectors";
import styled from "styled-components";
import color from "utils/constants/color";
import { saveAs } from 'file-saver';
import OverAllGraph from 'components/PlacementExam/OverAllGraph';
import AppDataTableComponent from './AppDataTableComponent';
import AppDataTable from "./AppDataTable";
import SkillReport from './SkillReport';
import ComparisonReport from './ComparisonReport';
import { captureException } from "@sentry/react";
import SentryWrap from 'components/Sentry';
import { useFirebase } from "containers/FirebaseContext";
import { doc, getDoc, setDoc } from "firebase/firestore";
import dayjs from 'utils/dayjsConfig';
import BarLoader from "components/UI/Loading/BarLoader";
import PlacementExamPointSystemViewModal from "components/PlacementExam/PlacementExamPointSystemViewModal";
import {
  getNativeNonNativeConfigRows,
  getNativeNonNativeLabelFromPoints,
  isNativeNonNativeBandConfigActive,
} from "components/PlacementExam/NativeNonNativeConfiguration";
import {
  getProficiencyConfigRows,
  getOverallProficiencyLabelForSubmission,
  getOverallProficiencyLabelFromPoints,
  isProficiencyBandConfigActive,
  PROFICIENCY_LEVEL_LABELS,
} from "components/PlacementExam/ProficiencyConfiguration";


const { Option } = Select;
const BORDERCOLOR = [
  "rgb(200,109,152)",
  "rgb(146,158,227)",
  "rgb(80,233,200)",
  "rgb(238,206,151)",
];
const SELECT_WIDTH = 200
const years = new Date().getFullYear();
const upcomming_year = `${years}-${years + 1}`;
const downcomming_year = `${years - 1}-${years}`;
const YEAR_SELECTER = [upcomming_year, downcomming_year]
const DEFAULT_PROFICIENCY_FILTER_OPTIONS = ["All", ...PROFICIENCY_LEVEL_LABELS];
const DEFAULT_NATIVE_NON_NATIVE_FILTER_OPTIONS = ["All"];
const SUBMISSIONS_TABLE_COLUMN_FIRESTORE_COLLECTION = "placement_exam_submissions_column_prefs";
const SUBMISSIONS_TABLE_COLUMNS = [
  { key: "sNo", label: "S.No" },
  { key: "studentId", label: "ID" },
  { key: "resumeCode", label: "Resume Code" },
  { key: "name", label: "Name" },
  { key: "gradeLevel", label: "Grade Level" },
  { key: "schoolName", label: "School Name" },
  { key: "submittedOn", label: "Submitted On" },
  { key: "result", label: "Result" },
  { key: "completed", label: "Completed" },
  { key: "placement", label: "Placement" },
  { key: "proficiency", label: "Proficiency" },
  { key: "nativeNonNative", label: "Native/NonNative" },
  { key: "viewReport", label: "View Report" },
];

const buildDefaultSubmissionColumnVisibility = () =>
  SUBMISSIONS_TABLE_COLUMNS.reduce((acc, col) => {
    acc[col.key] = true;
    return acc;
  }, {});

const mergeSubmissionColumnVisibilityFromRemote = (remote) => {
  const defaults = buildDefaultSubmissionColumnVisibility();
  if (!remote || typeof remote !== "object") return defaults;
  return { ...defaults, ...remote };
};

const SUBMISSION_STATUS_TABS = [
  { key: "All", label: "All" },
  { key: "Completed", label: "Completed" },
  { key: "Incomplete", label: "Incomplete" },
];
    //  ----------------------------------------------------------------------------
    //  Styles
    //  ----------------------------------------------------------------------------
    
    const StableWrapper = styled.div`
      width: 100%;
      overflow-x: auto;
      //   @media (max-width: 992px) {
      //     padding:24px 0px;
      //   }
    `;
    const StableWrapperMain = styled.div`
      padding: 0 4px;
      width: 100%;
    `;
    
    const FilterContainer = styled.div`
      font-size: 17px;
      font-weight: 500;
      width: 100%;
      margin-bottom: 8px;
    `;

    const SubmissionStatusTabsWrap = styled.div`
      width: 100%;
      margin-top: 12px;
      margin-bottom: 12px;
      .ant-tabs-nav {
        margin-bottom: 0;
      }
      .ant-tabs-nav-extra-content {
        display: flex;
        align-items: center;
      }
    `;
    
    const TextAreaAuto = styled(TextareaAutosize)`
      height: 200px;
      max-height: 210px;
      width: 100%;
      border-radius: 2px;
      padding: 5px;
      overflow: hidden;
      border-color: rgb(0 0 0 / 32%);
      ::focus-visible {
        outline: #03989e 1px !important;
        border: 1px solid #03989e !important;
      }
      ::focus {
        border-color: #03989e !important;
      }
    `;
    const BackButton = styled.button`
    background-color: ${color.indigo200};
    width: max-content;
    color: ${color.white};
    border: none;
    outline: none;
    padding: 5px 0px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding-left: 8px;
    padding-right: 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    @media (max-width: 450px) {
        padding-left: 0px;
    padding-right: 3px;
    }
   `
   const StyledSelect = styled(Select)`
   .ant-select-selector {
     border-radius: 0px !important;
     border: 1px solid #d9d9d9 !important; 
     background-color: rgb(237 237 237) !important;
     height: 40px !important;
     text-align: center;
     justify-content: center;
     align-items: center;
     cursor: pointer !important;
   }
   .ant-select-dropdown {
    
   }
 `;


const filterSubmissions = (
  submissions,
  searchByName,
  searchBySchool,
  searchByStudentId,
  activeSession,
  status,
  sort_by_level,
  proficiencyFilter,
  max_marks,
  proficiencyRows
) => {
  return submissions.filter((submission) => {
    try {
      const firstName = submission.firstName != null ? String(submission.firstName) : '';
      const lastName = submission.lastName != null ? String(submission.lastName) : '';
      const nameMatch =
        !searchByName ||
        firstName.toLowerCase().includes(searchByName.toLowerCase()) ||
        lastName.toLowerCase().includes(searchByName.toLowerCase());

      const schoolName = submission.school_name != null ? String(submission.school_name) : '';
      const schoolMatch =
        !searchBySchool ||
        schoolName.toLowerCase().includes(searchBySchool.toLowerCase());

      const studentId = submission.student_id != null ? String(submission.student_id) : '';
      const studentIdMatch =
        !searchByStudentId || studentId.toLowerCase().includes(searchByStudentId.toLowerCase());

      const [startYear, endYear] = activeSession.split("-").map(Number);
      const startDate = moment(`${startYear}-07-01`);
      const endDate = moment(`${endYear}-06-30`);
      const createdOnDate = moment(submission.created_on);
      const sessionMatch = createdOnDate.isBetween(startDate, endDate, "day", "[]");

      const statusMatch =
        status === "All" ||
        (status === "Completed" && submission.completed) ||
        (status === "Incomplete" && !submission.completed);
        let in_range = true;
        if(sort_by_level&&sort_by_level.legend&&sort_by_level.legend!="All"&&Array.isArray(sort_by_level.range)&&sort_by_level.range.length){
             const grade = Number(submission.grade) || 0;
             const min = Number(sort_by_level.range[0]);
             const max = Number(sort_by_level.range[1]);
             in_range = grade >= min && grade <= max && submission.graded;
        }

      const proficiencyLabel = getOverallProficiencyLabelFromPoints(
        Number(submission.grade),
        max_marks,
        proficiencyRows
      );
      const proficiencyMatch =
        proficiencyFilter === "All" ||
        (submission.graded && proficiencyLabel === proficiencyFilter);

      return nameMatch && schoolMatch && studentIdMatch && sessionMatch && statusMatch && in_range && proficiencyMatch;

    } catch (error) {
      captureException(`438 Error in filterSubmissions: ${error}`);
      return true;
    }
  }).sort((a, b) => (a.lastName || '').localeCompare(b.lastName || ''));
};
const FilterCard = ({
  search_by_name,
  setSearchByName,
  search_by_school,
  setSearchBySchool,
  search_by_student_id,
  setSearchByStudentId,
  search_by_grade,
  setSearchByGrade,
  gradeOptions,
  activeSession,
  setActiveSession,
  status,
  setStatus,
  sort_by_level,
  setSortbylevel,
  proficiencyFilter,
  setProficiencyFilter,
  nativeNonNativeFilter,
  setNativeNonNativeFilter,
  max_marks = 32,
  levels,
  schoolsList,
  schoolsLoading,
  onNameBlur,
  onStudentIdBlur,
  filterLoader,
  proficiencyFilterOptions = DEFAULT_PROFICIENCY_FILTER_OPTIONS,
  nativeNonNativeFilterOptions = DEFAULT_NATIVE_NON_NATIVE_FILTER_OPTIONS,
}) => {
  const [isDisabled, setIsDisabled] = useState(false);
  
  const handleReset = () => {
    setSearchByName("");
    setSearchBySchool("");
    setSearchByStudentId("");
    setSearchByGrade("All");
    setActiveSession(moment().get("month") < 7 ? downcomming_year : upcomming_year);
    setStatus("Completed");
    setSortbylevel({ legend: `All` });
    setProficiencyFilter("All");
    setNativeNonNativeFilter("All");
  };


 
  useEffect(() => {
    if (search_by_name === "" && search_by_student_id === "" && search_by_school === "" && status === "Completed" && activeSession === (dayjs().get("month") < 7 ? downcomming_year : upcomming_year) && sort_by_level.legend === "All" && proficiencyFilter === "All" && nativeNonNativeFilter === "All" && search_by_grade === "All") {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }
  }, [search_by_school, activeSession, status, sort_by_level.legend, proficiencyFilter, nativeNonNativeFilter, search_by_name, search_by_student_id, search_by_grade]);

  return (
    <SentryWrap>
      <Card className="setSerchSystem" type="inner" title="Filters">
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Card style={{ width: "100%" }}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={2} md={2} lg={2} xl={2} className="inputLabelCstm">
                <label style={{ display: "block" }}>Search by name</label>
                <Input
                  type="search"
                  placeholder="Enter name"
                  bordered={false}
                  style={{ height: "40px", border: "1px solid #d5cccc" }}
                  onChange={(e) => setSearchByName(e.target.value)}
                  onBlur={() => {
                    const trimmed = String(search_by_name ?? '').trim();
                    if (trimmed !== search_by_name) setSearchByName(trimmed);
                    onNameBlur?.();
                  }}
                  value={search_by_name}
                />
              </Col>
              <Col xs={24} sm={2} md={2} lg={2} xl={2} className="inputLabelCstm">
                <label style={{ display: "block" }}>Search by ID</label>
                <Input
                  type="search"
                  placeholder="Enter student ID"
                  bordered={false}
                  style={{ height: "40px", border: "1px solid #d5cccc" }}
                  onChange={(e) => setSearchByStudentId(e.target.value)}
                  onBlur={() => {
                    const trimmed = String(search_by_student_id ?? '').trim();
                    if (trimmed !== search_by_student_id) setSearchByStudentId(trimmed);
                    onStudentIdBlur?.();
                  }}
                  value={search_by_student_id}
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={3} className="inputLabelCstm">
                <label style={{ display: "block" }}>Search by school</label>
                <StyledSelect
                  placeholder="Select school"
                  style={{ width: "100%" }}
                  onChange={setSearchBySchool}
                  value={search_by_school}
                  loading={schoolsLoading}
                >
                  <Option key="all" value="">
                    All
                  </Option>
                  {schoolsList?.map((school) => (
                    <Option key={school.id} value={school.displayName}>
                      {school.displayName}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
              <Col sm={3} md={3} lg={3} xl={3} className="inputLabelCstm">
                <label style={{ display: "block" }}>By Session</label>
                <StyledSelect
                  value={activeSession}
                  style={{ width: "100%" }}
                  onChange={setActiveSession}
                >
                  {map(YEAR_SELECTER, (x) => (
                    <Option value={x} key={x}>
                      {x}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={3} className="inputLabelCstm">
                <label style={{ display: "block" }}>Level Suggested</label>
                <StyledSelect
                  value={sort_by_level.legend||'All'}
                  style={{ width: "100%" }}
                  onChange={v=>{
                    setSortbylevel(levels.find(k=>k.legend==v))
                  }}
                >
                  {map(levels, (x) => (
                    <Option value={x.legend} key={x.legend}>
                      {x.legend}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={3} className="inputLabelCstm">
                <label style={{ display: "block" }}>Overall Proficiency</label>
                <StyledSelect
                  value={proficiencyFilter}
                  style={{ width: "100%" }}
                  onChange={setProficiencyFilter}
                >
                  {map(proficiencyFilterOptions, (x) => (
                    <Option value={x} key={x}>
                      {x}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} xl={3} className="inputLabelCstm">
                <label style={{ display: "block" }}>Native/NonNative</label>
                <StyledSelect
                  value={nativeNonNativeFilter}
                  style={{ width: "100%" }}
                  onChange={setNativeNonNativeFilter}
                >
                  {map(nativeNonNativeFilterOptions, (x) => (
                    <Option value={x} key={x}>
                      {x}
                    </Option>
                  ))}
                </StyledSelect>
              </Col>
                <Col xs={24} sm={12} md={8} lg={8} xl={3} className="inputLabelCstm">
                  <label style={{ display: "block" }}>Search by grade</label>
                  <StyledSelect
                    value={search_by_grade}
                    style={{ width: "100%" }}
                    onChange={setSearchByGrade}
                  >
                    <Option value="All" key="All">
                      All
                    </Option>
                    {Array.isArray(gradeOptions) &&
                      gradeOptions.map((g) => (
                        <Option value={g} key={g}>
                          {g}
                        </Option>
                      ))}
                  </StyledSelect>
                </Col>
              <Col xs={24} sm={12} md={8} lg={4} xl={2} style={{ paddingTop: 22 }}>
                <Button type="primary"  disabled={isDisabled} onClick={handleReset} block style={{ height: 40 }} >
                  Reset
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Card>
    </SentryWrap>
  );
};
function getMaxGrade(assignment) {
  if (
    assignment &&
    typeof assignment === "object" &&
    Array.isArray(assignment.questions)
  ) {
    return assignment.questions.reduce((sum, section) => {
      const sectionMaxPoint = Number.parseFloat(section?.total_max_point ?? section?.max_point);
      if (!Number.isNaN(sectionMaxPoint)) {
        return sum + sectionMaxPoint;
      }
      if (Array.isArray(section?.questions)) {
        const nestedTotal = section.questions.reduce((nestedSum, question) => {
          const questionPoint = Number.parseFloat(question?.max_point);
          return nestedSum + (Number.isNaN(questionPoint) ? 0 : questionPoint);
        }, 0);
        return sum + nestedTotal;
      }
      return sum;
    }, 0);
  }
  return 32;
}

    const PlacementExamViewSubmissions = ({ userloading, districtOrgIdOverride }) => {
      const showAlert = useAlert();
      const dispatch = useDispatch();
      const placementExamList = usePlacementExamList()
      const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 50,
        totalLength: 0,
      });
      const [openViewShubmission, setOpenViewShubmission] = useState(false);
      const [openProficiencyReport, setOpenProficiencyReport] = useState(false);
      const [pointSystemModalOpen, setPointSystemModalOpen] = useState(false);
      const [reportsButtonState, setReportsButtonState] = useState(1);
      const location = useLocation();
  		const navigate = useNavigate();
      const search = useMemo(()=>queryString.parse(location.search),[location.search]);
      const [active_exam, setActiveExam] = useState({})
      const [loading, setLoading] = useState(false);
      const examSubmissions = usePlacementExamSubmissiomByexamcode()
      const [submissionList, setSubmissionList] = useState([])
      const currentUser= useCurrentUser();
      const isSuperAdmin = useMemo(() => currentUser?.role === "owe_admin", [currentUser?.role]);
      const { firestore } = useFirebase();
      const currentOrg = useCurrentOrg();
      const effectiveDistrictOrgId = useMemo(() => {
        if (districtOrgIdOverride != null && String(districtOrgIdOverride).trim() !== '') {
          return districtOrgIdOverride;
        }
        if (currentUser?.role === 'teacher' || currentUser?.role === 'placement_admin') {
          return currentOrg?.parentId;
        }
        return currentUser?.orgId;
      }, [districtOrgIdOverride, currentUser?.role, currentUser?.orgId, currentOrg?.parentId]);
      const [selectedSubmissions,setSelectedSubmissions] = useState({})
      const [activeSession, setActiveSession] = useState(moment().get("month") < 7 ? downcomming_year : upcomming_year)
      const initialActiveSessionRef = React.useRef(null);
      if (initialActiveSessionRef.current === null) {
        initialActiveSessionRef.current = moment().get("month") < 7 ? downcomming_year : upcomming_year;
      }
      const [status, setStatus] = useState('Completed')
      const [search_by_name, setSearchByName] = useState('');
      const [search_by_school, setSearchBySchool] = useState('');
      const [search_by_student_id, setSearchByStudentId] = useState('');
      const [search_by_grade, setSearchByGrade] = useState('All');
      const [debouncedSearchByName, setDebouncedSearchByName] = useState('');
      const [listOfGrades, setListOfGrades] = useState([]);
      const [debouncedSearchByStudentId, setDebouncedSearchByStudentId] = useState('');
      const [schoolsList, setSchoolsList] = useState([]);
      const [schoolsLoading, setSchoolsLoading] = useState(false);
      const [sort_by_level, setSortbylevel] = useState({
        legend: `All`,
      });
      const [proficiencyFilter, setProficiencyFilter] = useState('All');
      const [nativeNonNativeFilter, setNativeNonNativeFilter] = useState('All');
      const [submissionColumnVisibility, setSubmissionColumnVisibility] = useState(buildDefaultSubmissionColumnVisibility);
      const [submissionColumnPrefsReady, setSubmissionColumnPrefsReady] = useState(false);
      const submissionColumnFetchGenRef = React.useRef(0);
      const max_marks = useMemo(()=>getMaxGrade(active_exam),[active_exam])
      const [overAllData,setOverAllData] = useState({})
      const [loader,setLoader] = useState(false)
      const [overallReport, setOverallReport] = useState(null);
      const [reportByYear,setReportByYear] = useState(null);
      const exam_levels = useExamLevelConfig(active_exam)
      const orgConfig = usePlacementOrgConfig();
      const assignmentCodeForConfig = useMemo(
        () => active_exam?.assigned?.assignment_code || search?.exam_code || "",
        [active_exam, search?.exam_code]
      );
      const proficiency_config_rows = useMemo(
        () => getProficiencyConfigRows(orgConfig, assignmentCodeForConfig),
        [orgConfig, assignmentCodeForConfig]
      );
      const native_non_native_config_rows = useMemo(
        () => getNativeNonNativeConfigRows(orgConfig, assignmentCodeForConfig),
        [orgConfig, assignmentCodeForConfig]
      );
      const proficiencyFilterOptions = useMemo(() => {
        if (!isProficiencyBandConfigActive(proficiency_config_rows, max_marks)) {
          return DEFAULT_PROFICIENCY_FILTER_OPTIONS;
        }
        const titles = proficiency_config_rows
          .map((r) => String(r.title || "").trim())
          .filter(Boolean);
        if (titles.length > 0) return ["All", ...titles];
        return DEFAULT_PROFICIENCY_FILTER_OPTIONS;
      }, [proficiency_config_rows, max_marks]);
      const nativeNonNativeFilterOptions = useMemo(() => {
        if (!isNativeNonNativeBandConfigActive(native_non_native_config_rows, max_marks)) {
          return DEFAULT_NATIVE_NON_NATIVE_FILTER_OPTIONS;
        }
        const titles = native_non_native_config_rows
          .map((r) => String(r.title || "").trim())
          .filter(Boolean);
        if (titles.length > 0) return ["All", ...titles];
        return DEFAULT_NATIVE_NON_NATIVE_FILTER_OPTIONS;
      }, [native_non_native_config_rows, max_marks]);
      const examCodeChangedRef = React.useRef(false);
      const lastFetchedFiltersRef = React.useRef(undefined);
      const filtersRef = React.useRef({
        searchByName: '',
        searchBySchool: '',
        searchByStudentId: '',
        session: '',
        status: 'Completed',
        gradeMin: undefined,
        gradeMax: undefined,
        proficiency: '',
        nativeNonNative: '',
        max_grade: undefined,
        grade: undefined,
      });
      const levels = useMemo(() => {
        if (overAllData && Array.isArray(overAllData.levels)) {
          const lev = [{ legend: 'All' }];
          const maped_dt = overAllData.levels.map(k => ({
            legend: k.title,
            range: k.range
          }));
          lev.push(...maped_dt);
          return lev;
        }
        return getLevelsByConfig(max_marks || 32, exam_levels);
      }, [max_marks, overAllData, exam_levels])
      const DEBOUNCE_MS = 500;
      const debouncedSetNameRef = React.useRef(
        debounce((value) => setDebouncedSearchByName(value), DEBOUNCE_MS)
      );
      const debouncedSetStudentIdRef = React.useRef(
        debounce((value) => setDebouncedSearchByStudentId(value), DEBOUNCE_MS)
      );
      useEffect(() => {
        debouncedSetNameRef.current(search_by_name);
        return () => debouncedSetNameRef.current.cancel();
      }, [search_by_name]);
      useEffect(() => {
        debouncedSetStudentIdRef.current(search_by_student_id);
        return () => debouncedSetStudentIdRef.current.cancel();
      }, [search_by_student_id]);
      useEffect(() => {
        if (!currentUser?.id || !firestore) {
          setSubmissionColumnPrefsReady(false);
          setSubmissionColumnVisibility(buildDefaultSubmissionColumnVisibility());
          return;
        }
        const userId = String(currentUser.id);
        submissionColumnFetchGenRef.current += 1;
        const gen = submissionColumnFetchGenRef.current;
        setSubmissionColumnPrefsReady(false);
        setSubmissionColumnVisibility(buildDefaultSubmissionColumnVisibility());
        let cancelled = false;
        (async () => {
          try {
            const snap = await getDoc(doc(firestore, SUBMISSIONS_TABLE_COLUMN_FIRESTORE_COLLECTION, userId));
            if (cancelled || submissionColumnFetchGenRef.current !== gen) return;
            const remote = snap.exists() ? snap.data()?.columnVisibility : null;
            setSubmissionColumnVisibility(mergeSubmissionColumnVisibilityFromRemote(remote));
          } catch (error) {
            captureException(error);
            if (!cancelled && submissionColumnFetchGenRef.current === gen) {
              setSubmissionColumnVisibility(buildDefaultSubmissionColumnVisibility());
            }
          } finally {
            if (!cancelled && submissionColumnFetchGenRef.current === gen) {
              setSubmissionColumnPrefsReady(true);
            }
          }
        })();
        return () => {
          cancelled = true;
        };
      }, [currentUser?.id, firestore]);
      useEffect(() => {
        if (!submissionColumnPrefsReady) return;
        const userId = currentUser?.id;
        if (!userId || !firestore) return;
        const uid = String(userId);
        const handle = window.setTimeout(() => {
          void (async () => {
            try {
              await setDoc(
                doc(firestore, SUBMISSIONS_TABLE_COLUMN_FIRESTORE_COLLECTION, uid),
                {
                  userId: uid,
                  columnVisibility: submissionColumnVisibility,
                  updatedAt: new Date().toISOString(),
                },
                { merge: true },
              );
            } catch (error) {
              captureException(error);
            }
          })();
        }, 500);
        return () => window.clearTimeout(handle);
      }, [submissionColumnVisibility, currentUser?.id, firestore, submissionColumnPrefsReady]);
      const visibleSubmissionColumnCount = useMemo(
        () => SUBMISSIONS_TABLE_COLUMNS.filter((c) => submissionColumnVisibility[c.key]).length,
        [submissionColumnVisibility],
      );
      const submissionTableColSpan = Math.max(visibleSubmissionColumnCount, 1);
      const showSubmissionCol = (key) => Boolean(submissionColumnVisibility[key]);
      const handleSubmissionColumnToggle = (key, checked) => {
        setSubmissionColumnVisibility((prev) => {
          if (checked) {
            return { ...prev, [key]: true };
          }
          const wouldRemain = SUBMISSIONS_TABLE_COLUMNS.filter(
            (c) => c.key !== key && prev[c.key],
          ).length;
          if (wouldRemain === 0) {
            return prev;
          }
          return { ...prev, [key]: false };
        });
      };
      const submissionColumnsPopover = (
        <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 220, maxHeight: 360, overflowY: "auto" }}>
          {SUBMISSIONS_TABLE_COLUMNS.map((col) => {
            const checked = Boolean(submissionColumnVisibility[col.key]);
            const disableUncheck = visibleSubmissionColumnCount === 1 && checked;
            return (
              <Checkbox
                key={col.key}
                checked={checked}
                disabled={disableUncheck}
                onChange={(e) => handleSubmissionColumnToggle(col.key, e.target.checked)}
              >
                {col.label}
              </Checkbox>
            );
          })}
        </div>
      );
      const submissionFilters = useMemo(() => {
        const hasLevelRange = sort_by_level?.legend && sort_by_level.legend !== 'All' && Array.isArray(sort_by_level.range) && sort_by_level.range.length >= 2;
        const gradeNum =
          search_by_grade === 'All' || search_by_grade === undefined || search_by_grade === null
            ? undefined
            : Number(search_by_grade);
        return {
          searchByName: String(debouncedSearchByName ?? '').trim().toLowerCase() || '',
          searchBySchool: String(search_by_school ?? '').trim() || '',
          searchByStudentId: String(debouncedSearchByStudentId ?? '').trim().toLowerCase() || '',
          session: String(activeSession ?? '').trim() || '',
          status,
          gradeMin: hasLevelRange ? sort_by_level.range[0] : undefined,
          gradeMax: hasLevelRange ? sort_by_level.range[1] : undefined,
          proficiency: proficiencyFilter && proficiencyFilter !== 'All' ? proficiencyFilter : '',
          nativeNonNative:
            nativeNonNativeFilter && nativeNonNativeFilter !== 'All' ? nativeNonNativeFilter : '',
          max_grade: max_marks,
          grade: gradeNum != null && !Number.isNaN(gradeNum) ? gradeNum : undefined,
        };
      }, [debouncedSearchByName, search_by_school, debouncedSearchByStudentId, activeSession, status, sort_by_level, proficiencyFilter, nativeNonNativeFilter, max_marks, search_by_grade]);
      useEffect(() => {
        const gradeNum =
          search_by_grade === 'All' || search_by_grade === undefined || search_by_grade === null
            ? undefined
            : Number(search_by_grade);
        filtersRef.current = {
          searchByName: String(debouncedSearchByName ?? '').trim().toLowerCase() || '',
          searchBySchool: String(search_by_school ?? '').trim() || '',
          searchByStudentId: String(debouncedSearchByStudentId ?? '').trim().toLowerCase() || '',
          session: String(activeSession ?? '').trim() || '',
          status,
          gradeMin: (sort_by_level?.legend && sort_by_level.legend !== 'All' && Array.isArray(sort_by_level.range) && sort_by_level.range.length >= 2) ? sort_by_level.range[0] : undefined,
          gradeMax: (sort_by_level?.legend && sort_by_level.legend !== 'All' && Array.isArray(sort_by_level.range) && sort_by_level.range.length >= 2) ? sort_by_level.range[1] : undefined,
          proficiency: proficiencyFilter && proficiencyFilter !== 'All' ? proficiencyFilter : '',
          nativeNonNative:
            nativeNonNativeFilter && nativeNonNativeFilter !== 'All' ? nativeNonNativeFilter : '',
          max_grade: max_marks,
          grade: gradeNum != null && !Number.isNaN(gradeNum) ? gradeNum : undefined,
        };
      }, [debouncedSearchByName, search_by_school, debouncedSearchByStudentId, activeSession, status, sort_by_level, proficiencyFilter, nativeNonNativeFilter, max_marks, search_by_grade]);

      const hasActiveFilters = useMemo(() => {
        const hasSearch =
          String(debouncedSearchByName || '').trim() !== '' ||
          String(search_by_school || '').trim() !== '' ||
          String(debouncedSearchByStudentId || '').trim() !== '';
        const hasLevel = sort_by_level?.legend && sort_by_level.legend !== 'All';
        const hasProficiency = proficiencyFilter && proficiencyFilter !== 'All';
        const hasNativeNonNative = nativeNonNativeFilter && nativeNonNativeFilter !== 'All';
        const hasGrade = search_by_grade && search_by_grade !== 'All';
        const hasStatus = status && status !== 'Completed';
        const hasSessionChange = activeSession !== initialActiveSessionRef.current;
        const hasColumnVisibilityChange = SUBMISSIONS_TABLE_COLUMNS.some(
          (c) => submissionColumnVisibility[c.key] === false,
        );
        return hasSearch || hasLevel || hasProficiency || hasNativeNonNative || hasGrade || hasStatus || hasSessionChange || hasColumnVisibilityChange;
      }, [
        debouncedSearchByName,
        search_by_school,
        debouncedSearchByStudentId,
        sort_by_level,
        proficiencyFilter,
        nativeNonNativeFilter,
        search_by_grade,
        status,
        activeSession,
        submissionColumnVisibility,
      ]);

      const gradeOptions = useMemo(() => {
        
        if (Array.isArray(active_exam?.grade) && active_exam.grade.length > 0) {
          const fromExam = active_exam.grade
            .map((g) => Number(g))
            .filter((n) => !Number.isNaN(n));
            return Array.from(new Set(fromExam)).sort((a, b) => a - b);
          }
        const values = new Set();
        if (Array.isArray(listOfGrades)) {
          listOfGrades.forEach((submission) => {
            const gradeValue = Number(submission);
            if (!Number.isNaN(gradeValue)) values.add(gradeValue);
          });
        }
        return Array.from(values).sort((a, b) => a - b);
      }, [active_exam, listOfGrades]);

      useEffect(() => {
        if (search_by_grade === "All" || search_by_grade === undefined || search_by_grade === null) return;
        const targetGrade = Number(search_by_grade);
        if (Number.isNaN(targetGrade) || !gradeOptions.includes(targetGrade)) {
          setSearchByGrade("All");
        }
      }, [gradeOptions, search_by_grade]);
      async function listExam() {
        try {
          if (!placementExamList || placementExamList.length == 0) {
            await dispatch(handleListPlacementexamForDistrict(effectiveDistrictOrgId))
          }
        } catch (error) {
          captureException(`439 Error in listExam: ${error}`);
          console.error(error, "error in loading placement exam")
        }
      }

      async function getAllSubmissionRow(code){
        try {
          const data = await dispatch(handleGetAllSubmissionRow(code))
          if (data && data.success) {
            setPagination((prev) => ({ ...prev, totalLength: Number(data.data.total_submissions) || 0 }))
          }
        } catch (error) {
          captureException(`441 Error in getAllSubmissionRow: ${error}`);
          console.error(error, "error in getting all submission row")
        }
      }
      const [filterLoader, setFilterLoader] = useState(false);
      const [xlsxDownloading, setXlsxDownloading] = useState(false);
      const listSubmissions = async(code, pageOffset = 0, limit = pagination.pageSize, filters)=>{
        setFilterLoader(true);
        const currentFilters = filters != null ? filters : filtersRef.current;
       try {
          const result = await dispatch(handleListPlacementexamSubmissionsByCodeFiltered(code, limit, pageOffset * limit, currentFilters));
          if (result && Array.isArray(result.data)) {
            setSubmissionList(result.data);
          }
          if (result && Array.isArray(result.grade)) {
            setListOfGrades(result.grade);
          }
          if (result && typeof result.total === 'number') {
            setPagination((prev) => ({ ...prev, totalLength: result.total }));
          }
          await listExam();
        } catch (error) {
          captureException(`440 Error in listSubmissions: ${error}`);
        } finally {
          setFilterLoader(false);
        }
      } 
      const getExamAveg = async () => {
        try {
          if (search && search.exam_code) {
            setLoader(true)
            setOverAllData({})
            const data = await handleGetOverallAverage(search.exam_code)
            if (data && data.success) {
              setOverAllData(data.data)
            } else {
              if (data && data.data == 'no_submission') {
                showAlert("No submission found", "error")
              } else if (data && data.data == 'no_exam') {
                showAlert("No exam found", "error")
              }
              else {
                showAlert("Something went wrong", "error")
              }
            }
          }
        } catch (error) {
          captureException(`441 Error in getExamAveg: ${error}`);
        } finally {
          setLoader(false)
        }
      }
      useEffect(() => {
        if (typeof examSubmissions == "object") {
          if (examSubmissions[search.exam_code]) {
            const data =examSubmissions[search.exam_code] || []
            setSubmissionList(data)
          } else {
            setSubmissionList([])
          }
        } else {
          setSubmissionList([])
        }
      }, [examSubmissions, search])

      const getSubmissionData = async () => {
        if (search && search.exam_code) {
          examCodeChangedRef.current = true;
          setPagination((prev) => (prev.current === 1 ? prev : { ...prev, current: 1 }));
          await listExam();
          getExamAveg();
        }
      }

      useEffect(() => {
        getSubmissionData();
      }, [search]);

      useEffect(() => {
        if (search?.exam_code == null) return;
        const filtersKey = JSON.stringify(submissionFilters);
        const didFiltersChange = lastFetchedFiltersRef.current !== filtersKey;
        if (didFiltersChange) {
          lastFetchedFiltersRef.current = filtersKey;
        }
        const pageToFetch = examCodeChangedRef.current ? 0 : (didFiltersChange ? 0 : pagination.current - 1);
        if (examCodeChangedRef.current) {
          examCodeChangedRef.current = false;
        }
        listSubmissions(search.exam_code, pageToFetch, pagination.pageSize, filtersRef.current);
      }, [search?.exam_code, pagination.current, pagination.pageSize, submissionFilters]);

      const prevFiltersRef = React.useRef(undefined);
      useEffect(() => {
        if (prevFiltersRef.current !== undefined && JSON.stringify(prevFiltersRef.current) !== JSON.stringify(submissionFilters)) {
          setPagination((prev) => ({ ...prev, current: 1 }));
        }
        prevFiltersRef.current = submissionFilters;
      }, [submissionFilters]);

      useEffect(() => {
        if (search && search.exam_id) {
          const exam = find(placementExamList, (x) => x.id == search.exam_id);
          if (exam) {
            setActiveExam(exam)
          }
        } else {
          setActiveExam({})
        }
      }, [search, placementExamList])

      const fetchSchools = async () => {
        try {
          setSchoolsLoading(true);
          const response = await dispatch(handleGetSchoolsForOrg(0, 1000, effectiveDistrictOrgId));
          if (response && response.success) {
            const { schools } = response.data || {};
            setSchoolsList(schools || []);
          }
        } catch (error) {
          console.error("Error fetching schools:", error);
        } finally {
          setSchoolsLoading(false);
        }
      };

      useEffect(() => {
        if (effectiveDistrictOrgId) {
          fetchSchools();
        }
      }, [effectiveDistrictOrgId]);

      useEffect(() => {
        if (effectiveDistrictOrgId) {
          void dispatch(handleGetPlacementOrgConfig(effectiveDistrictOrgId));
        }
      }, [dispatch, effectiveDistrictOrgId]);

      useEffect(() => {
        if (proficiencyFilter !== "All" && !proficiencyFilterOptions.includes(proficiencyFilter)) {
          setProficiencyFilter("All");
        }
      }, [proficiencyFilterOptions, proficiencyFilter]);

      useEffect(() => {
        if (nativeNonNativeFilter !== "All" && !nativeNonNativeFilterOptions.includes(nativeNonNativeFilter)) {
          setNativeNonNativeFilter("All");
        }
      }, [nativeNonNativeFilterOptions, nativeNonNativeFilter]);
      const handlePageChange = (page, pageSize) => {
        setPagination((prev) => ({
          ...prev,
          current: page,
          pageSize: pageSize || prev.pageSize,
        }));
        document.body.scrollTop = 0;
      };
      const backToButton = () => {
        navigate(-1);
      }

      const copyResumeCode = async (code) => {
        const text = String(code ?? "");
        if (!text) return;
        try {
          await navigator.clipboard.writeText(text);
          showAlert("Resume code copied", "info");
        } catch (error) {
          captureException(error);
          showAlert("Could not copy", "error");
        }
      };

      const confirmReactivateSubmission = (row) => {
        Modal.confirm({
          title: "Reactivate this submission?",
          content: "The student can resume the exam with the same code.",
          okText: "Reactivate",
          cancelText: "Cancel",
          onOk: async () => {
            const res = await dispatch(handleReactivatePlacementExamSubmission(row.id));
            if (res && res.success) {
              showAlert("Submission reactivated. It now appears under the Incomplete tab.", "info");
              if (search?.exam_code) {
                await listSubmissions(search.exam_code, pagination.current - 1, pagination.pageSize, filtersRef.current);
                await getAllSubmissionRow(search.exam_code);
              }
            } else {
              showAlert(res?.message || "Could not reactivate", "error");
            }
          },
        });
      };

      const confirmMarkSubmissionComplete = (row) => {
        Modal.confirm({
          title: "Mark this submission as complete?",
          content: "This will mark the exam as completed for this student and queue AI grading.",
          okText: "Mark complete",
          cancelText: "Cancel",
          onOk: async () => {
            try {
              const payload = { completed: true, id: row.id };
              const g = row.grade;
              if (g !== undefined && g !== null && !Number.isNaN(Number(g))) {
                payload.grade = Number(g);
              }
              const res = await dispatch(handleUpdatePlacementExamSubmissions(payload));
              if (res && res.success) {
                await handlePlacementExamAiGrading(row.id);
                showAlert("Marked as complete", "info");
                if (search?.exam_code) {
                  await listSubmissions(search.exam_code, pagination.current - 1, pagination.pageSize, filtersRef.current);
                  await getAllSubmissionRow(search.exam_code);
                }
              } else {
                showAlert(res?.message || "Could not update submission", "error");
              }
            } catch (error) {
              captureException(error);
              showAlert("Could not update submission", "error");
            }
          },
        });
      };
      const confirmRegradeSubmission = (row) => {
        Modal.confirm({
          title: "Re-grade this submission?",
          content: "This will re-run AI grading and replace the current AI grade.",
          okText: "Re-grade",
          cancelText: "Cancel",
          onOk: async () => {
            try {
              const res = await handlePlacementExamAiReGrading(row.id);
              if (res && !res.error) {
                if (res.update_data) {
                  setSubmissionList((prev) =>
                    Array.isArray(prev) ? prev.map((item) => (item.id === row.id ? { ...item, ...res.update_data } : item)) : prev
                  );
                  setSelectedSubmissions((prev) =>
                    prev && prev.id === row.id ? { ...prev, ...res.update_data } : prev
                  );
                }
                showAlert("Re-grade queued successfully", "info");
              } else {
                showAlert(res?.message || "Could not trigger re-grade", "error");
              }
            } catch (error) {
              captureException(error);
              showAlert("Could not trigger re-grade", "error");
            }
          },
        });
      };

      const getName = (row) => {
        return `${row.lastName||''} ${row.firstName||''}`
      }
      const getSubmisstedOn = (row) => {
        if (row && row.created_on) {
          return moment(row.created_on).format("YYYY-MM-DD hh:mm a");
        }
        return "";
      };
      const downloadXLSX = async (dataArray) => {
        if (!Array.isArray(dataArray) || dataArray.length === 0) return;
    
        const filteredData = dataArray.map(({ id, answers, ai_feedback, ai_suggestion, ...rest }) => rest);
        const assignmentMaxGrade = Number(max_marks) || 32;
        const visibility = submissionColumnVisibility;
        const exportColDefs = SUBMISSIONS_TABLE_COLUMNS.filter(
          (c) => c.key !== 'viewReport' && visibility[c.key],
        );
        if (!exportColDefs.length) {
          showAlert('Turn on at least one data column in Columns to export.', 'info');
          return;
        }

        const getLevelSuggested = (row) => {
          if (!row || (row.grade !== 0 && !row.grade)) return '-';
          const exam_level_config = levels;
          const gradeNum = Number(row.grade);
          const level = exam_level_config.find(
            (l) =>
              Array.isArray(l.range) &&
              l.range.length >= 2 &&
              gradeNum >= Number(l.range[0]) &&
              gradeNum <= Number(l.range[1]),
          );
          return level?.legend ?? '-';
        };

        const getProficiencyLabel = (row) =>
          getOverallProficiencyLabelForSubmission(row, assignmentMaxGrade, proficiency_config_rows, {
            orgConfig,
            assignment: active_exam,
          });

        const getCellValue = (item, colKey, rowIndexOneBased) => {
          switch (colKey) {
            case 'sNo':
              return rowIndexOneBased;
            case 'studentId':
              return item.student_id != null && item.student_id !== '' ? item.student_id : '-';
            case 'resumeCode':
              return item.session_code != null && item.session_code !== '' ? item.session_code : '-';
            case 'name':
              return `${item.lastName || ''} ${item.firstName || ''}`.trim() || '-';
            case 'gradeLevel': {
              if (item.grade_level == null || item.grade_level === '') return '-';
              const s = String(item.grade_level).trim();
              const m = s.match(/\d+/);
              if (!m) return '-';
              return String(parseInt(m[0], 10));
            }
            case 'schoolName':
              return item.school_name ? item.school_name : '-';
            case 'submittedOn':
              return item.created_on ? moment(item.created_on).format('YYYY-MM-DD hh:mm a') : '-';
            case 'result':
              return item.grade === 0 || item.grade ? item.grade : '-';
            case 'completed':
              return item.completed ? 'Yes' : 'No';
            case 'placement':
              return getLevelSuggested(item);
            case 'proficiency':
              return getProficiencyLabel(item);
            case 'nativeNonNative':
              return item.grade !== 0 && !item.grade
                ? '-'
                : getNativeNonNativeLabelFromPoints(
                    item.grade,
                    assignmentMaxGrade,
                    native_non_native_config_rows,
                  );
            default:
              return '';
          }
        };

        const headers = exportColDefs.map((c) => c.label);
        const bodyRows = filteredData.map((item, index) =>
          exportColDefs.map((c) => getCellValue(item, c.key, index + 1)),
        );

        const ExcelJS = (await import('exceljs')).default;
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Exported Data');
        worksheet.addRow(headers);
        bodyRows.forEach((row) => {
          worksheet.addRow(row);
        });
        const minColWidth = 15;
        headers.forEach((_, i) => {
            const col = worksheet.getColumn(i + 1);
            if (!col.width || col.width < minColWidth) col.width = minColWidth;
        });
        const headerRow = worksheet.getRow(1);
        const headerFillArgb = 'FF2E75B6';
        headerRow.eachCell((cell) => {
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: headerFillArgb },
            };
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        });
        const lightBlueArgb = 'FFDDEBF7';
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber%2 === 1) return;
            row.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: lightBlueArgb },
                };
            });
        });
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, `${active_exam.displayName || new Date().getTime()}_placement_exam_submissions.xlsx`);
    };

      const fetchAllSubmissionsUnfiltered = async () => {
        const code = search?.exam_code;
        if (!code) return [];
        const pageSize = 50;
        let offset = 0;
        let all = [];
        while (true) {
          const result = await dispatch(handleListPlacementexamSubmissionsByCode(code, pageSize, offset, true));
          if (!result?.success || !Array.isArray(result.data)) break;
          all = all.concat(result.data);
          if (result.data.length < pageSize) break;
          offset += pageSize;
        }
        return all;
      };

      const fetchAllSubmissionsFiltered = async () => {
        const code = search?.exam_code;
        if (!code) return [];
        const pageSize = 50;
        let offset = 0;
        let all = [];
        const filters = filtersRef.current;
        let total = Infinity;
        while (all.length < total) {
          const result = await dispatch(handleListPlacementexamSubmissionsByCodeFiltered(code, pageSize, offset, filters, true));
          if (!result?.success || !Array.isArray(result.data)) break;
          if (typeof result.total === 'number') total = result.total;
          all = all.concat(result.data);
          if (result.data.length < pageSize) break;
          offset += pageSize;
        }
        return all;
      };

      const onDownloadAllSubmissions = async () => {
        setXlsxDownloading(true);
        try {
          const rows = await fetchAllSubmissionsUnfiltered();
          if (!rows.length) {
            showAlert('No submissions to export', 'info');
            return;
          }
          await downloadXLSX(rows);
        } finally {
          setXlsxDownloading(false);
        }
      };

      const onDownloadFilteredSubmissions = async () => {
        setXlsxDownloading(true);
        try {
          const rows = await fetchAllSubmissionsFiltered();
          if (!rows.length) {
            showAlert('No submissions to export', 'info');
            return;
          }
          await downloadXLSX(rows);
        } finally {
          setXlsxDownloading(false);
        }
      };
 
      const onViewSubmission = async row => {
        if(!overAllData||typeof overAllData!=="object"||Object.keys(overAllData).length==0){
          await getExamAveg()
        }
        setSelectedSubmissions(row);
        setOpenViewShubmission(true)
      }

      const calculateLevelSuggested = (row) => {
        if (!row || (row.grade !== 0 && !row.grade)) return '-';
        const submission = row;
        const assignment = active_exam;
        const max_marks = assignment && Array.isArray(assignment.questions) 
          ? assignment.questions.reduce((prev, currentVal) => prev + Number(currentVal.max_point||0), 0) 
          : 100;
        const exam_levels_config = levels;
        const gradeNum = Number(submission.grade);
        const level = exam_levels_config.find(
          (l) =>
            Array.isArray(l.range) &&
            l.range.length >= 2 &&
            gradeNum >= Number(l.range[0]) &&
            gradeNum <= Number(l.range[1]),
        );
        return level?.legend ?? '-';
      }

      const getOverallProficiencyLabel = (row) =>
        getOverallProficiencyLabelForSubmission(row, max_marks, proficiency_config_rows, {
          orgConfig,
          assignment: active_exam,
        });

      const getGradeLevelDisplay = (row) => {
        if (!row || row.grade_level == null || row.grade_level === "") return "-";
        const s = String(row.grade_level).trim();
        const m = s.match(/\d+/);
        if (!m) return "-";
        return String(parseInt(m[0], 10));
      };

      const getNativeNonNativeLabel = (row) => {
        if (!row || (row.grade !== 0 && !row.grade)) return "-";
        return getNativeNonNativeLabelFromPoints(row.grade, max_marks, native_non_native_config_rows);
      };

      const onViewProficiencyReport = async row => {
        if(!overAllData||typeof overAllData!=="object"||Object.keys(overAllData).length==0){
          await getExamAveg()
        }
        setSelectedSubmissions(row);
        setOpenProficiencyReport(true)
      }

      const fetchOverallReport = async () => {
        try {
          setLoader(true);
          const data = await dispatch(
            handlePlacementOverallReport(effectiveDistrictOrgId, search.exam_code),
          );
          if(data?.data){
            setOverallReport(data?.data);
          }
        } catch (error) {
          captureException(error);
        } finally {
          setLoader(false);
        }
      };

      const fetchReportByYear = async () => {
        try {
          setLoader(true);
          const data = await dispatch(handleReportByYear(effectiveDistrictOrgId, search.exam_code));
          if(data?.data){
            setReportByYear(data?.data);
          }
        } catch (error) {
          captureException(error);
        }finally{
          setLoader(false);
        }
      };

      useEffect(() => {
        if (search && search.exam_code) {
          Promise.allSettled([fetchOverallReport()]);
        }
      }, []);
      return (
        <>
              <BackButton style={{ marginRight: "8px", whiteSpace: "nowrap", display: "flex", alignItems: "center", padding: "8px 12px", minWidth: "fit-content" }} onClick={backToButton}>
                <ArrowBack style={{ fontSize: '14px', marginRight: '4px' }} />
                {active_exam&&active_exam.displayName?active_exam.displayName:''}
              </BackButton>


           <div className='reportsButtonUpr'>
            <div className='reportsButton'>
              <button 
                  className={reportsButtonState === 1 ? 'cstmTabactive' : ''}
                  onClick={() => setReportsButtonState(1)}
              >
                  Overall Report
              </button>
              <button 
                  className={reportsButtonState === 2 ? 'cstmTabactive' : ''}
                  onClick={() => setReportsButtonState(2)}
              >
                  Students Report
              </button>
              <button 
                  className={reportsButtonState === 3 ? 'cstmTabactive' : ''}
                  onClick={() => setReportsButtonState(3)}
              >
                  Skill Report
              </button>
              <button 
                  className={reportsButtonState === 4 ? 'cstmTabactive' : ''}
                  onClick={() => setReportsButtonState(4)}
              >
                  Comparison Report
              </button>
              <button
                  type="button"
                  onClick={() => setPointSystemModalOpen(true)}
              >
                  Overall Point System
              </button>
            </div>
            {reportsButtonState === 2 && (
              hasActiveFilters ? (
                <Dropdown
                  disabled={xlsxDownloading}
                  menu={{
                    items: [
                      {
                        key: 'all',
                        label: 'Download all',
                        onClick: () => {
                          void onDownloadAllSubmissions();
                        },
                      },
                      {
                        key: 'filtered',
                        label: 'Download filtered',
                        onClick: () => {
                          void onDownloadFilteredSubmissions();
                        },
                      },
                    ],
                  }}
                  trigger={['click']}
                >
                  <Button type="primary" color="#03989e" loading={xlsxDownloading}>
                    <DownloadOutlined /> xlsx <DownOutlined />
                  </Button>
                </Dropdown>
              ) : (
                <Button type="primary" color="#03989e" loading={xlsxDownloading} onClick={() => void onDownloadFilteredSubmissions()}>
                  <DownloadOutlined /> xlsx
                </Button>
              )
            )}
           </div>


          {reportsButtonState === 1 && <AppDataTable overAllData={overAllData} overallReport={overallReport} loader={loader} />}
          {reportsButtonState === 2 && <>
        <SpinLoader dataloader={loading || loader} />
          <StableWrapperMain>
            
            <FilterContainer className="FilterHeading">
              <FilterCard
                activeSession={activeSession}
                search_by_name={search_by_name}
                search_by_school={search_by_school}
                search_by_student_id={search_by_student_id}
                search_by_grade={search_by_grade}
                setSearchByGrade={setSearchByGrade}
                gradeOptions={gradeOptions}
                status={status}
                setStatus={setStatus}
                setActiveSession={setActiveSession}
                setSearchByName={setSearchByName}
                setSearchBySchool={setSearchBySchool}
                setSearchByStudentId={setSearchByStudentId}
                setSortbylevel={setSortbylevel}
                sort_by_level={sort_by_level}
                proficiencyFilter={proficiencyFilter}
                setProficiencyFilter={setProficiencyFilter}
                nativeNonNativeFilter={nativeNonNativeFilter}
                setNativeNonNativeFilter={setNativeNonNativeFilter}
                max_marks={max_marks}
                levels={levels}
                schoolsList={schoolsList}
                schoolsLoading={schoolsLoading}
                onNameBlur={() => setDebouncedSearchByName(search_by_name)}
                onStudentIdBlur={() => setDebouncedSearchByStudentId(search_by_student_id)}
                proficiencyFilterOptions={proficiencyFilterOptions}
                nativeNonNativeFilterOptions={nativeNonNativeFilterOptions}
              />
            </FilterContainer>
            <SubmissionStatusTabsWrap>
              <Tabs
                activeKey={status}
                onChange={setStatus}
                items={SUBMISSION_STATUS_TABS}
                tabBarExtraContent={
                  <Popover content={submissionColumnsPopover} title="Table columns" trigger="click" placement="bottomRight">
                    <Button type="default" icon={<SettingOutlined />}>
                      Columns
                    </Button>
                  </Popover>
                }
              />
            </SubmissionStatusTabsWrap>
            <BarLoader isLoading={filterLoader}/>
            <StableWrapper>
              <TableContainer
                component={Paper}
                style={{
                  maxHeight: "65vh",
                  overflowY: "auto",
                  overflowX: "auto",
                  marginTop: 20,
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  borderRadius: 8,
                }}
              >
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  style={{
                    minWidth: 1100,
                    backgroundColor: "#fff",
                  }}
                  sx={{
                    "& .MuiTableHead-root .MuiTableCell-root": {
                      backgroundColor: "#f5f5f5",
                      borderBottom: "2px solid #e0e0e0",
                      padding: "12px 16px",
                    },
                    "& .MuiTableBody-root .MuiTableCell-root": {
                      padding: "10px 16px",
                      verticalAlign: "middle",
                    },
                    "& .MuiTableFooter-root .MuiTableCell-root": {
                      position: "sticky",
                      bottom: 0,
                      zIndex: 1,
                      backgroundColor: "#f5f5f5",
                      borderTop: "1px solid #e0e0e0",
                      padding: "0px 8px",
                    },
                  }}
                >

                  <TableHead>
                    <TableRow>
                      {showSubmissionCol("sNo") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          S.No
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("studentId") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          ID
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("resumeCode") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Resume Code
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("name") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Name
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("gradeLevel") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Grade Level
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("schoolName") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          School Name
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("submittedOn") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Submitted On
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("result") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Result
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("completed") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Completed
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("placement") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Placement
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("proficiency") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Proficiency
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("nativeNonNative") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          Native/NonNative
                        </TableCell>
                      ) : null}
                      {showSubmissionCol("viewReport") ? (
                        <TableCell style={{ textAlign: "left", fontSize: 16, fontWeight: "600", whiteSpace: "nowrap" }}>
                          View Report
                        </TableCell>
                      ) : null}
                    </TableRow>
                  </TableHead>
                  {filterLoader ? (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={submissionTableColSpan} align="center">
                          <div style={{ padding: '20px 0' }}>
                            <Loading size={30} />
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : (
                    <TableBody>
                    {isEmpty(submissionList) &&
                      (userloading ? (
                        <Loading size={30} />
                      ) : (
                        <TableRow key={"0"} style={{ border: 0 }}>
                          <TableCell colSpan={submissionTableColSpan} style={{ textAlign: "center" }}>
                            No submissions found
                          </TableCell>
                        </TableRow>
                      ))}
                    {!isEmpty(submissionList) &&
                      submissionList
                        .map((row,index) => {
                          return (
                            <TableRow
                              key={row.id}
                              style={{
                                position: 'relative',
                                zIndex: 0,
                              }}
                            >
                              {showSubmissionCol("sNo") ? (
                                <TableCell>
                                  {(pagination.current - 1) * pagination.pageSize + index + 1}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("studentId") ? (
                                <TableCell>
                                  {" "}
                                  {row && row.student_id ? row.student_id : "-"}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("resumeCode") ? (
                                <TableCell>
                                  {row && row.session_code ? (
                                    <Dropdown
                                      menu={{
                                        items: row.completed
                                          ? [
                                              { key: "copy", label: "Copy" },
                                              { key: "reactivate", label: "Reactivate" },
                                            ]
                                          : [
                                              { key: "copy", label: "Copy" },
                                              { key: "markComplete", label: "Mark as complete" },
                                            ],
                                        onClick: ({ key, domEvent }) => {
                                          domEvent?.stopPropagation?.();
                                          if (key === "copy") {
                                            void copyResumeCode(row.session_code);
                                          } else if (key === "reactivate") {
                                            confirmReactivateSubmission(row);
                                          } else if (key === "markComplete") {
                                            confirmMarkSubmissionComplete(row);
                                          }
                                        },
                                      }}
                                      trigger={["click"]}
                                    >
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          color: BORDERCOLOR[0],
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {row.session_code}
                                      </span>
                                    </Dropdown>
                                  ) : (
                                    "-"
                                  )}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("name") ? (
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    color: BORDERCOLOR[0],
                                  }}
                                >
                                  {getName(row)}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("gradeLevel") ? (
                                <TableCell style={{ textAlign: "left", maxWidth: 120 }}>
                                  {getGradeLevelDisplay(row)}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("schoolName") ? (
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    color: BORDERCOLOR[0],
                                    maxWidth: 380,
                                  }}
                                  onClick={() => {}}
                                >
                                  {row && row?.school_name ? row?.school_name : "-"}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("submittedOn") ? (
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    maxWidth: 380,
                                  }}
                                >
                                  {getSubmisstedOn(row)}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("result") ? (
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    color: row && row.assigned && row.assigned.status ? color.green100 : color.red,
                                    maxWidth: 380,
                                  }}
                                >
                                  {row && (row.grade === 0 || row.grade) ? row.grade : "-"}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("completed") ? (
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    color: row && row.assigned && row.assigned.status ? color.green100 : color.red,
                                    maxWidth: 380,
                                  }}
                                >
                                  {row && row.completed ? "Yes" : "No"}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("placement") ? (
                                <TableCell>{calculateLevelSuggested(row)}</TableCell>
                              ) : null}
                              {showSubmissionCol("proficiency") ? (
                                <TableCell style={{ textAlign: "left", maxWidth: 380 }}>
                                  {getOverallProficiencyLabel(row)}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("nativeNonNative") ? (
                                <TableCell style={{ textAlign: "left", maxWidth: 140, whiteSpace: "nowrap" }}>
                                  {getNativeNonNativeLabel(row)}
                                </TableCell>
                              ) : null}
                              {showSubmissionCol("viewReport") ? (
                                <TableCell style={{ textAlign: "left", maxWidth: 380 }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: 4, flexWrap: "nowrap" }}>
                                    <Tooltip title="Student Report">
                                      <IconButton size="small" style={{ padding: 4 }} onClick={() => onViewSubmission(row)}>
                                        <EyeOutlined style={{ color: color.green100, fontSize: 18 }} />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Proficiency Report">
                                      <IconButton size="small" style={{ padding: 4 }} onClick={() => onViewProficiencyReport(row)}>
                                        <Article style={{ color: color.green100, fontSize: 18 }} />
                                      </IconButton>
                                    </Tooltip>
                                    {row?.completed && isSuperAdmin ? (
                                      <Dropdown
                                        trigger={["click"]}
                                        menu={{
                                          items: [{ key: "regrade", label: "Re-grade" }],
                                          onClick: ({ key }) => {
                                            if (key === "regrade") {
                                              confirmRegradeSubmission(row);
                                            }
                                          },
                                        }}
                                      >
                                        <span style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}>
                                          <Tooltip title="AI Grade (click for options)">
                                            <span style={{ display: "inline-flex", alignItems: "center" }}>
                                              {row && row.graded ? (
                                                <TaskAlt style={{ color: color.green100, fontSize: 22 }} />
                                              ) : (
                                                <HourglassEmpty style={{ color: "#faad14", fontSize: 22 }} />
                                              )}
                                            </span>
                                          </Tooltip>
                                        </span>
                                      </Dropdown>
                                    ) : (
                                      <Tooltip title="AI Grade">
                                        <span style={{ display: "inline-flex", alignItems: "center" }}>
                                          {row && row.graded ? (
                                            <TaskAlt style={{ color: color.green100, fontSize: 22 }} />
                                          ) : (
                                            <HourglassEmpty style={{ color: "#faad14", fontSize: 22 }} />
                                          )}
                                        </span>
                                      </Tooltip>
                                    )}
                                  </div>
                                </TableCell>
                              ) : null}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  )}
            
                  <TableFooter>
                    <TableRow
                      className="placement-sticky-footer"
                      sx={{
                        position: 'relative',
                        bottom: 0,
                        zIndex: 10,
                        backgroundColor: '#fff',
                        boxShadow: '0 -2px 8px rgba(0,0,0,0.08)',
                        '& td': {
                          backgroundColor: '#fff',
                        },
                      }}
                    >
                      <TableCell
                        colSpan={submissionTableColSpan}
                        align="left"
                        sx={{
                          paddingLeft: 2,
                          backgroundColor: '#fff',
                          borderTop: '1px solid #e0e0e0',
                          position: 'relative',
                          zIndex: 10,
                        }}
                      >
                        {!isEmpty(submissionList) && (
                          <Pagination
                            current={pagination.current}
                            pageSize={pagination.pageSize}
                            total={pagination.totalLength || 0}
                            onChange={handlePageChange}
                            showSizeChanger={false}
                            itemRender={(page, type, originalElement) => {
                              if (type === 'page' && page === pagination.current) {
                                return (
                                  <div className="ant-pagination-item-active custom-active-page">
                                    {page}
                                  </div>
                                );
                              }
                              return originalElement;
                            }}
                          />
                        )}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
               
                  {/* <TableFooter> */}
                    {/* <TableRow> */}
                      {/* {!isEmpty(submissionList) && (
                        <TablePagination
                          // colSpan={10}
                          count={totalSubmissionsCount}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                          backIconButtonProps={{ color: "secondary" }}
                          nextIconButtonProps={{ color: "secondary" }}
                          sx={{ borderBottom: "none", justifyContent: "flex-start", paddingLeft: "16px", textAlign: "left" }}
                        />
                      )} */}
                    {/* </TableRow> */}
                  {/* </TableFooter> */}
                </Table>
              </TableContainer>
            </StableWrapper>
          </StableWrapperMain>
          <Modal
            footer={null}
            title={`Submission`}
            centered
            open={openViewShubmission}
            destroyOnHidden={true}
            onOk={() => setOpenViewShubmission(false)}
            onCancel={() => setOpenViewShubmission(false)}
            width={"100%"}
            height={"100%"}
            bodyStyle={{ padding: 8 }}
            className="FilterHeading placementQstnModal"
          >
            <PlacementExamViewSubmission
              submission={selectedSubmissions || {}}
              assignment={active_exam}
              overAllData={overAllData}
              onOk={() => {

              }}
            />
          </Modal>
          <Modal
            footer={null}
            // title={`Individual Student Proficiency Report`}
            centered
            open={openProficiencyReport}
            destroyOnHidden={true}
            onOk={() => setOpenProficiencyReport(false)}
            onCancel={() => setOpenProficiencyReport(false)}
            width={"100%"}
            height={"100%"}
            bodyStyle={{ padding: 8 }}
            className="FilterHeading placementQstnModal stdntProfRprt"
          >
            <IndividualStudentProficiencyReport
              submission={selectedSubmissions || {}}
              assignment={active_exam}
              overAllData={overAllData}
              proficiencyRows={proficiency_config_rows}
              onOk={() => {

              }}
            />
          </Modal>
          </>
          }
          {reportsButtonState === 3 && <SkillReport overallReport={overallReport} />}
          {reportsButtonState === 4 && <ComparisonReport reportByYear={reportByYear} fetchReportByYear={fetchReportByYear} loader={loader} /> }



        <PlacementExamPointSystemViewModal
          open={pointSystemModalOpen}
          onClose={() => setPointSystemModalOpen(false)}
          assignment={active_exam}
          proficiencyRows={proficiency_config_rows}
          maxExamPoints={max_marks}
        />
        </>
      );
    };
    
    
    export default PlacementExamViewSubmissions;
    